/** Letter spacing. `label` is the uppercase small-caps treatment. */
export const tracking = {
  tight: 'var(--tracking-tight)',
  normal: 'var(--tracking-normal)',
  wide: 'var(--tracking-wide)',
  label: 'var(--tracking-label)',
} as const;

export type TrackingToken = keyof typeof tracking;
